import { render, staticRenderFns } from "./TableKanbanView.vue?vue&type=template&id=6bfa18f3&scoped=true"
import script from "./TableKanbanView.vue?vue&type=script&lang=js"
export * from "./TableKanbanView.vue?vue&type=script&lang=js"
import style0 from "./TableKanbanView.vue?vue&type=style&index=0&id=6bfa18f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfa18f3",
  null
  
)

export default component.exports